import { useStoreState } from '@src/store/store';
import { TRootModel } from '@src/store/models/root/root.types';

type TUseArrowHoveredToDelete = TRootModel['canvas']['arrowHoveredToDelete'];

export function useArrowHoveredToDelete(): TUseArrowHoveredToDelete {
  return useStoreState((state) => state.canvas.arrowHoveredToDelete);
}
